

























import { Component, Prop, Vue } from "vue-property-decorator";

interface ComboItem {
  key: number | null;
  value: string;
}

@Component({})
export default class ComboTopicos extends Vue {
  //Props
  @Prop({ default: true }) readonly todosTipos!: boolean;
  @Prop({ default: null }) readonly value!: number | number[] | null;
  @Prop({ default: false }) readonly multiple!: boolean;
  @Prop({ default: null }) readonly rules!: Array<(v: any) => string | true>;

  //Atributos
  itemsTipos: ComboItem[] = [
    {
      key: null,
      value: "Todos",
    },
    {
      key: 1,
      value: "Agenda",
    },
    {
      key: 2,
      value: "Clientes",
    },
    {
      key: 3,
      value: "Compras",
    },
    {
      key: 4,
      value: "Cadastro",
    },
    {
      key: 5,
      value: "Email",
    },
    {
      key: 6,
      value: "Empréstimo",
    },
    {
      key: 7,
      value: "Estoque",
    },
    {
      key: 8,
      value: "Financeiro",
    },
    {
      key: 9,
      value: "Pagamento",
    },
    {
      key: 10,
      value: "Segurança",
    },
    {
      key: 11,
      value: "Sistema",
    },
    {
      key: 12,
      value: "Suporte",
    },
    {
      key: 13,
      value: "Vendas",
    },
    {
      key: 14,
      value: "Loja Online",
    },
  ];

  //Computados
  get tipo() {
    return this.value;
  }

  mounted() {
    if (!this.todosTipos) this.itemsTipos.splice(0, 1);
  }

  onChangeTipo(val: number | number[] | null) {
    this.$emit("input", val);
  }
}
